import { Navigate } from 'react-router'
import { TablePageSkeleton } from '../../components/skeletons'
import { useBugReportEnabled } from './useBugReportEnabled'

export function BugReportAccessGuard({ children }: { children: React.ReactNode }) {
  const { enabled, loading } = useBugReportEnabled()

  if (loading) {
    return <TablePageSkeleton rows={3} />
  }

  if (!enabled) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
